module.exports = __webpack_public_path__ + "img/p2-35.f992e641.png";